import { ModalBody } from 'reactstrap';

import styled from 'styled-components';

const StyledModalBody = styled(ModalBody)`
  padding: 24px 24px 0px 24px;
  max-height: calc(100vh - 120px);
  overflow: auto;

  .modal-footer,
  .form-footer {
    position: sticky;
    bottom: 0px;
    width: 100%;
    background: #fff;
    text-align: right;
    padding: 24px 0;
    margin: 0;
    box-shadow: 0px 5px 0px 5px #fff;
  }
`;

export default StyledModalBody;
